export const ordinal = number => {
    const s = ["th", "st", "nd", "rd"];
    const v = number%100;
    return number + (s[(v-20)%10] || s[v] || s[0]);
}

export const numberWithCommas = number => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }